import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../facility/stockReturnRequestApproval/ContextAPI';
import Index from '../facility/stockReturnRequestApproval/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestFacilityApproval() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-facility-approval']) return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
